<script-loader [src]="fontFaceScriptUrl"></script-loader>
<css-loader [src]="fontFaceCssUrl"></css-loader>
